<template>
    <div class="config">
        <div class="configItem">
            <el-input size="small" v-model="setTingObj.shopSelectConfig.selectUrl" placeholder="请输入跳转链接"></el-input>
        </div>
        <div class="configItem">
            <el-input size="small" v-model="setTingObj.shopSelectConfig.selectName" placeholder="字段名称"></el-input>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            setTingObj:{
                type: Object,
                default: {}
            }
        },
        data(){
            return{

            }
        }
    }
</script>

<style scoped lang="scss">
    .config{
        .configItem{
            width: 100%;
            margin-top: 20px;
        }
    }
</style>